import services from './../../services/service'; // Service Class
let service = new services();

export default {
    name: 'Points',
    data () {
        return {
            sellpoint: {},
            products: {},
            img_url: service.imageURL,
            ajk: this.$route.path,
            
        }
    },
  
    methods: {
        prep: function() {
            var reg = new RegExp("www|sitename|test|localhost:2082");
            var parts = window.location.host.split(".");
            //return Home;
            return parts[0];
        },
        getSellpoint() {
            let search = this.prep();
            service.getBusinesses(this,search).then(data => {
                if(data.body.status == 200) {
                    this.sellpoint = data.body.data;
                    this.products = this.getProducts(this.sellpoint.business_id);
                }
            }).catch((err) => {
                if(err) {
                     //toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },
        getSellpointSearch() { //maybe deprecated
            let search = this.$route.query.pg;
            service.getBusinessSearch(this,search).then(data => {
                if(data.body.status == 200) {
                    this.sellpoint = data.body.data;
                    this.products = this.getProducts(this.sellpoint.business_id);
                }
            }).catch((err) => {
                if(err) {
                     //toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        },
        getProducts(sellpoint) {
            service.getBusinessProducts(this,sellpoint).then(data => {
                if(data.body.status == 200) {
                    this.products = data.body.data;
                }
            }).catch((err) => {
                if(err) {
                     //toastr.error('Sorry, could not process information', 'Warning!');
                }
            })
        }

        
    },
    created: function(){
        this.getSellpoint();
    }
}


// WEBPACK FOOTER //
// ./src/pages/Points/script.js